
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/quiz/[step]",
      function () {
        return require("private-next-pages/quiz/[step].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/quiz/[step]"])
      });
    }
  